import { Injectable } from '@angular/core';
import { RestApiService } from '../shared/rest-api.service';


@Injectable({
  providedIn: 'root'
})
export class StudyModuleService {

  endpoint: string = 'study-module';

  constructor(private api: RestApiService) { }

  getStudyModule(id: string): any {
    return this.api.getOne(this.endpoint, id);
  }

  getType(id: string): any {
    return this.api.getSubList('lu', id);
  }

}
